import { Title, Typography, SuccessGif, SuccessWrapper } from '~components'
import { usePreventBrowserBack } from '~hooks'
import { urlHandler } from '~utils/path'
import { useEffect } from 'react'
import { track } from '@amplitude/analytics-browser'

const Success = () => {
  const url = `${process.env.REACT_APP_FRETEBRAS_SITE}/fretes/`

  usePreventBrowserBack()
  useEffect(() => {
    track('perfil_sucesso')
  }, [])

  setTimeout(() => {
    window.location.href = urlHandler(url)
  }, 3500)

  return (
    <SuccessWrapper role="region">
      <SuccessGif />
      <Title>Senha criada com sucesso!</Title>
      <Typography as="b">
        A partir de agora você vai usá-la para acessar a Fretebras.
      </Typography>
    </SuccessWrapper>
  )
}

export default Success
